import { getStoredRelays } from './relay';
import { postSignature } from './relay';
import { signMessage } from './crypto';
import type { MsgSignature } from '../types/message';

/**
 * Sign hash-nonce with privateKey and post MsgSignature to all enabled relays.
 * Returns number of relays that accepted.
 */
export async function signAndPostLoginChallenge(
  hash: string,
  nonce: string,
  privateKey: string,
  publicKey: string,
): Promise<number> {
  const messageToSign = `${hash}-${nonce}`;
  const signature = signMessage(messageToSign, privateKey);
  const msgSig: MsgSignature = {
    signature: { hash, cle_publique: publicKey, signature, nonce },
    hash_cible: hash,
  };
  const relays = getStoredRelays().filter((r) => r.enabled);
  let ok = 0;
  for (const r of relays) {
    try {
      await postSignature(r.endpoint, msgSig);
      ok++;
    } catch (err) {
      console.error(`Post signature to ${r.endpoint} failed:`, err);
    }
  }
  return ok;
}
